module.exports = __webpack_public_path__ + "img/blog1.32f13417.jpg";